
<button mat-button (click) = "openSyncLog()" class="sync-status-button">
  <div fxLayout="row" fxLayoutAlign="start center" >
    <span> Sync Status: </span>
    <div [hidden]="syncStatus !== SyncStatusEnum.Synced" class="status-icon not-synced">
      <mat-icon class="downloaded">check_circle</mat-icon>
    </div>
    <div [hidden]="syncStatus !== SyncStatusEnum.HasChanges" >
      <mat-icon class="not-synced">cloud_upload</mat-icon>
    </div>
    <div [hidden]="syncStatus !== SyncStatusEnum.Syncing" >
        <mat-spinner color="warn"></mat-spinner>
    </div>
  </div>
</button>
